import { controls,grouped } from "../controls";
const process_bulk_remittances = {
label: "Process Bulk Remittances",
pageLabel: "Process Bulk Remittances",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
]
,form:[
...controls.displayText({ tab: "general", label: "Client",star:false}),
...controls.oc({ tab: "general", c: "Client", placeHolder: "Client Code", name: "client_code",fastpath: "clients" ,isReadOnly:"edit" ,hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "client_display"}),
...controls.checkBox({ tab: "general", label: "Update Previous Status",default:false, name: "update_previous_status" ,isReadOnly:"edit"  }),
...controls.checkBox({ tab: "general", label: "Process Remittance",default:false, name: "process_remittance" ,isReadOnly:"edit"  }),
]
,history:{
perPage: 10,
reportHeader: "Process Bulk Remittances",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Update Previous Status",accessor: "update_previous_status",type:'tick'},
{Header: "Process Remittance",accessor: "process_remittance",type:'tick'},
{Header: "Total Amount",accessor: "total_amount",},
{Header: "Total Count",accessor: "total_count",},
{Header: "Success Amount",accessor: "success_amount",},
{Header: "Success Count",accessor: "success_count",},
{Header: "Failed Amount",accessor: "failed_amount",},
{Header: "Failed Count",accessor: "failed_count",},
]}};
export default process_bulk_remittances;